import { Map } from 'immutable';
import * as actionTypes from 'constants/actionTypes';

const init = Map({});

const pageReducer = (state = init, action) => {
    switch (action.type) {
    case actionTypes.GO_TO_PAGE:
        return state.set('goToPage', action.pageName).set('pageProps', action.pageProps);
    default:
        return state;
    }
};

export default pageReducer;
